module.exports = __webpack_public_path__ + "res/ic_arrow_small_big.f58a25843b56a2707c3847a338eb1193.png";